<template>
  <div class="tempus-iframe-pre-cart-container pre-cart pb-4" v-if="selectedRoomSlot" id="preCart">
    <div class="container py-4">

      <div :class="$deploymentCurrent == 'trappedinfiction' ? '' : 'bgDarker'">

        <div v-if="! iframeScrollTransition" class="mb-4">
          <button class="calendarWeekGrid_Button_PrevNext" @click="backToCalendar">
            <span class="material-icons">arrow_back</span>
            <p class="mb-0">Back To Calendar</p>
          </button>

          <button class="calendarWeekGrid_Button_PrevNext" @click="toPlayerEntry">
            <span class="material-icons">arrow_downward</span>
            <p class="mb-0">Select Players</p>
          </button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="alert alert-blue">
              <div class="row">
                <template v-if="$deploymentIs('breakescape') || (external === false && firstShow && firstShow.charAt(0) == 'r')">
                  <div class="col">
                    <h4 v-if="! fromVirtualGame" :class="$deploymentIs('cryptology') ? 'heading' : 'font-weight-bold'" :style="$deploymentIn(['taketheexit']) ? 'letter-spacing: 0;' : ''">
                      <span class="material-icons md-48" style="position: relative; top: 6px;">{{ room.type_material_icon }}</span> You have selected:
                    </h4>
                    <h3 :class="$deploymentIs('cryptology') ? 'heading' : ''">{{ room.name }}</h3>
                    <h4 v-if="! fromVirtualGame" :class="$deploymentIs('cryptology') ? 'font-mon' : ''" :style="$deploymentIn(['taketheexit']) ? 'letter-spacing: 0;' : ''">
                      {{ selectedRoomSlot.start | moment('ddd Do MMM YYYY') }} @ {{ roomSlotTimeText }}
                    </h4>
                    <h5 v-if="selectedRoomSlot.public_booking">
                      <span class="material-icons" style="position: relative; top: 6px;">screen_lock_landscape</span> {{ selectedRoomSlot.availableRemainingTickets }} of {{ selectedRoomSlot.override_play_max ? selectedRoomSlot.override_play_max : room.play_max}} tickets remaining &mdash; Public Booking
                    </h5>
                    <h5 v-if="room.nickname == 'area515' && (numberOfAdults == 2 || numberOfAdults == 3)" class="text-tempus-blue-200">
                      <span class="material-icons">lock_clock</span> This is a 75 minute game for 2s or 3s
                    </h5>
                    <h5 v-if="$deploymentCurrent == 'housetrap' && room.slug == 'killjoy'" class="text-tempus-blue-200">
                      <span class="material-icons" style="position: relative; top: 6px;">lock_clock</span> This is a 45-70 minute game
                    </h5>
                    <h5 v-else-if="room.duration != 60" class="text-tempus-blue-200">
                      <span class="material-icons" style="position: relative; top: 6px;">lock_clock</span> This is a {{ room.duration }} minute game
                    </h5>
                    <h6 v-if="room.room_address">
                      <span class="material-icons" style="position: relative; top: 6px;">not_listed_location</span> {{ room.room_address }}
                    </h6>
                    <h6 v-if="$deploymentIs('breakescape')">
                      <template v-if="location.slug == 'loughborough'">
                        <span class="material-icons" style="position: relative; top: 6px;">not_listed_location</span> 58/59 Baxter Gate, Loughborough, LE11 1TH
                      </template>
                      <template v-else-if="location.slug == 'nottingham'">
                        <span class="material-icons" style="position: relative; top: 6px;">not_listed_location</span> 9a Market Street, Nottingham, NG1 6HY
                      </template>
                    </h6>
                  </div>
                  <div class="col">
                    <div class="row text-center">
                      <div class="col">
                        <span class="mt-2 md-48 material-icons text-tempus-blue-900">people_alt</span><br>
                        <span class="font-weight-bold">{{ roomSlotMinimimumPlayers }}-{{ room.play_max }} players</span>
                      </div>
                      <div class="col">
                        <span class="mt-2 md-48 material-icons text-tempus-blue-900">history_toggle_off</span><br>
                        <template v-if="$deploymentCurrent == 'housetrap' && room.slug == 'killjoy'">
                          45 - 70 min
                        </template>
                        <template v-else>
                          <span class="font-weight-bold">{{ room.duration }} minutes</span>
                        </template>
                      </div>
                    </div>
                    <div v-if="room.caveat" class="row mt-4 text-left">
                      <div class="col">
                        <p class="text-tempus-red font-weight-bold" v-html="preCaveat + room.caveat"></p>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <img id="room_mp" :src="'/img/mp/mp-ls-' + room.nickname + '.jpg'" class="img-fluid booking-summary-ls-mp">
                  </div>
                </template>
                <template v-else>
                  <div class="col-sm-8">
                    <!-- ROOM CONFIRMATION / ADVERTISING / BLURB -->
                    <h4 v-if="! fromVirtualGame" :class="$deploymentIs('cryptology') ? 'heading' : 'font-weight-bold'" :style="$deploymentIn(['taketheexit']) ? 'letter-spacing: 0;' : ''">
                      <span class="material-icons md-48" style="position: relative; top: 6px;">{{ room.type_material_icon }}</span> You have selected:
                    </h4>
                    <h3 :class="$deploymentIs('cryptology') ? 'heading' : ''">{{ room.name }}</h3>
                    <h4 v-if="! fromVirtualGame" :class="$deploymentIs('cryptology') ? 'font-mon' : ''" :style="$deploymentIn(['taketheexit']) ? 'letter-spacing: 0;' : ''">
                      {{ selectedRoomSlot.start | moment('ddd Do MMM YYYY') }} @ {{ roomSlotTimeText }}
                    </h4>
                    <h5 v-if="selectedRoomSlot.public_booking">
                      <span class="material-icons" style="position: relative; top: 6px;">screen_lock_landscape</span> {{ selectedRoomSlot.availableRemainingTickets }} of {{ selectedRoomSlot.override_play_max ? selectedRoomSlot.override_play_max : room.play_max}} tickets remaining &mdash; Public Booking
                    </h5>
                    <h5 v-if="room.nickname == 'area515' && (numberOfAdults == 2 || numberOfAdults == 3)" class="text-tempus-blue-200">
                      <span class="material-icons">lock_clock</span> This is a 75 minute game for 2s or 3s
                    </h5>
                    <h5 v-if="$deploymentCurrent == 'housetrap' && room.slug == 'killjoy'" class="text-tempus-blue-200">
                      <span class="material-icons" style="position: relative; top: 6px;">lock_clock</span> This is a 45-70 minute game
                    </h5>
                    <h5 v-else-if="room.duration != 60" class="text-tempus-blue-200">
                      <span class="material-icons" style="position: relative; top: 6px;">lock_clock</span> This is a {{ room.duration }} minute game
                    </h5>
                    <h6 v-if="room.room_address">
                      <span class="material-icons" style="position: relative; top: 6px;">not_listed_location</span> {{ room.room_address }}
                    </h6>
                    <h6 v-if="$deploymentIs('breakescape')">
                      <template v-if="location.slug == 'loughborough'">
                        <span class="material-icons" style="position: relative; top: 6px;">not_listed_location</span> 58/59 Baxter Gate, Loughborough, LE11 1TH
                      </template>
                      <template v-else-if="location.slug == 'nottingham'">
                        <span class="material-icons" style="position: relative; top: 6px;">not_listed_location</span> 9a Market Street, Nottingham, NG1 6HY
                      </template>
                    </h6>
                    <p v-for="blurb in room.blurbs" v-html="blurb"></p>
                  </div>
                  <div class="col-sm-4">
                    <!-- ROOM IMAGE / BASIC DETAILS -->
                    <!-- TO DO - this is where room difficulty and stuff should go -->
                    <div class="row">
                      <div class="col">
                        <img id="room_mp" :src="'/img/mp/mp-ls-' + room.nickname + '.jpg'" class="img-fluid booking-summary-ls-mp">
                      </div>
                    </div>
                    <div class="row text-center">
                      <div class="col">
                        <span class="mt-2 md-48 material-icons text-tempus-blue-900">people_alt</span><br>
                        <span class="font-weight-bold">{{ roomSlotMinimimumPlayers }}-{{ room.play_max }} players</span>
                      </div>
                      <div class="col">
                        <span class="mt-2 md-48 material-icons text-tempus-blue-900">history_toggle_off</span><br>
                        <template v-if="$deploymentCurrent == 'housetrap' && room.slug == 'killjoy'">
                          45 - 70 min
                        </template>
                        <template v-else>
                          <span class="font-weight-bold">{{ room.duration }} minutes</span>
                        </template>
                      </div>
                    </div>
                    <div v-if="room.caveat" class="row mt-4 text-left">
                      <div class="col">
                        <p class="text-tempus-red font-weight-bold" v-html="preCaveat + room.caveat"></p>
                      </div>
                    </div>
                  </div>

                </template>
              </div>
            </div>
          </div>
          <div class="col-12" id="chooseYourTeam">
            <div class="row mb-2">
              <div class="col">
                <h3 :class="$deploymentIs('cryptology') ? 'heading' : 'font-weight-bold'" :style="$deploymentIn(['breakescape', 'taketheexit']) ? 'letter-spacing: 0;' : ''">Choose Your Team</h3>
              </div>
            </div>
            <div class="row mb-2" id="playerSelection">
              <div class="col-sm-12 col-lg-6">
                <!-- PLAYER SELECTION -->

                <div v-if="! fromVirtualGame" class="form-group">
                  <template v-if="pricingStyle == 'CHILD_TOTAL_PLAYERS'">
                    <div class="row">
                      <div class="col">
                        <label class="col-form-label font-weight-bold"><sup class="tempus-iframe-text-warning" data-toggle="tooltip" title="Required">(*)</sup> {{ bookingLabelAdults }}:</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <button
                              class="btn btn-red"
                              type="button"
                              :disabled="disableReduceAdultsQtyButton"
                              @click="numberOfAdults = numberOfAdults - 1">&minus;</button>
                          </div>
                          <input
                            type="number"
                            min="1"
                            class="form-control no-number-spinner"
                            disabled="disabled"
                            v-model.number="numberOfAdults">
                          <div class="input-group-append">
                            <button
                              class="btn btn-green"
                              type="button"
                              :disabled="selectedRoomSlot.availableRemainingTickets - numberOfPlayers == 0"
                              @click="numberOfAdults = numberOfAdults + 1">&plus;</button>
                          </div>
                        </div>
                      </div>
                      <div class="col input-group">
                        <label class="col-form-label font-weight-bold">Children</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <button
                              class="btn btn-red"
                              type="button"
                              :disabled="disableReduceChildrenQtyButton"
                              @click="numberOfChildren = numberOfChildren - 1">&minus;</button>
                          </div>
                          <input
                            type="number"
                            min="1"
                            class="form-control no-number-spinner"
                            disabled="disabled"
                            v-model.number="numberOfChildren">
                          <div class="input-group-apppend">
                            <button
                              class="btn btn-green"
                              type="button"
                              :disabled="selectedRoomSlot.availableRemainingTickets - numberOfPlayers == 0"
                              @click="numberOfChildren = numberOfChildren + 1">&plus;</button>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 mt-2">
                        <p v-if="numberOfPlayers < roomSlotMinimimumPlayers" class="mb-0 font-weight-bold font-italic tempus-iframe-text-warning">Please add more players to your experience</p>
                        <p v-if="pricingStyle == 'CHILD_TOTAL_PLAYERS' && ! allowZeroAdults && numberOfAdults == 0" class="mb-0 font-weight-bold font-italic tempus-iframe-text-warning">At least 1 adult must be present and selected</p>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="hasChildPricing && ! room.pricing_disable_child">
                    <div class="row">
                      <label :for="$id('numberOfAdults')" class="col-sm-4 col-form-label font-weight-bold text-right pt-0"><sup class="tempus-iframe-text-warning" data-toggle="tooltip" title="Required">(*)</sup> {{ bookingLabelAdults }}:</label>
                      <div class="col-sm-8">
                        <select-two
                          ref="numPlayersInput"
                          :id="$id('numberOfAdults')"
                          v-model="numberOfAdults"
                          :settings="{minimumResultsForSearch: Infinity, width: '100%', dropdownParent: $refs.bookModal}"
                          :options="numPlayersInputOptions"
                          :placeholder="bookingLabelAdultsSelection"
                          :invalid="numberOfAdultsError"
                          required>
                          <option value=""></option> <!-- Required for placeholder to work-->
                        </select-two>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <label :for="$id('numberOfChildren')" class="col-sm-4 col-form-label font-weight-bold text-right pt-2">Children</label>
                      <div class="col-sm-8">
                        <select-two
                          ref="numPlayersInput"
                          :id="$id('numberOfChildren')"
                          v-model="numberOfChildren"
                          :settings="{minimumResultsForSearch: Infinity, width: '100%', dropdownParent: $refs.bookModal}"
                          :options="numChildrenInputOptions"
                          :disabled="numberOfAdults < 2"
                          placeholder="Select number of children"
                          :invalid="numberOfChildrenError">
                          <option value="0">0 children</option> <!-- Required for placeholder to work-->
                        </select-two>
                      </div>
                      <label class="col-sm-12 col-form-label pt-0 font-italic">{{ bookingChildCaveat }}</label>
                      <label v-if="$deploymentIs('escapable') && hasChildPricing && (room.nickname == 'loudini' || room.nickname == 'loupuzz')" class="col-sm-12 col-form-label pt-0 font-italic text-deep-orange">Children under 13 are not allowed to participate in The Great Loudini, and we do not accommodate children's parties in this game. Therefore, children's pricing is the same as adults.</label>
                    </div>
                  </template>
                  <template v-else>
                    <div class="row">
                      <label :for="$id('numberOfAdults')" class="col-lg-4 col-xl-3 col-form-label font-weight-bold pt-0"><sup class="tempus-iframe-text-warning" data-toggle="tooltip" title="Required">(*)</sup> Players</label>
                      <div class="col-lg-8 col-xl-9">
                        <select-two
                          ref="numPlayersInput"
                          :id="$id('numberOfAdults')"
                          v-model="numberOfAdults"
                          :settings="{minimumResultsForSearch: Infinity, width: '100%', dropdownParent: $refs.bookModal}"
                          :options="numPlayersInputOptions"
                          placeholder="Select number of players"
                          :invalid="numberOfPlayersError"
                          required>
                          <option value=""></option> <!-- Required for placeholder to work-->
                        </select-two>
                      </div>
                    </div>
                  </template>
                </div>
              </div>

              <div class="col-sm-12 col-lg-6">
                <!-- COST SUMMARY -->
                <div class="alert alert-blue mb-4" role="alert" :style="pricingStyle == 'CHILD_TOTAL_PLAYERS' ? 'position: relative; top: 24px;' : ''">
                  <div class="input-group input-group-lg">
                    <h4 class="mb-0" :style="$deploymentIn(['breakescape', 'taketheexit']) ? 'letter-spacing: 0;' : ''">
                      <p class="mb-0">Experience Cost:
                        <strong v-if="pricingStyle == 'CHILD_TOTAL_PLAYERS' && numberOfPlayers < roomSlotMinimimumPlayers">More Players Required</strong>
                        <strong v-else>{{ getPrice(numberOfAdults, numberOfChildren) | money }}</strong>
                      </p>
                      <p v-if="room.duration != 60 && $deploymentCurrent != 'ctrlaltesc' && ! ($deploymentCurrent == 'housetrap' && room.slug == 'killjoy') && $deploymentCurrent != 'roomescapersboston'" class="text-tempus-blue-200 mt-2 mb-0">As this is a {{ room.duration }} minute game, pricing may be different than 60 minute pricing.</p>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="hasRoomQuestions">
          <hr class="border-white">

          <h4 id="roomQuestions" :class="$deploymentIs('cryptology') ? 'font-mon' : ''" :style="$deploymentIn(['breakescape', 'taketheexit']) ? 'letter-spacing: 0;' : ''">{{ room ? room.name : '' }} Confirmations</h4>

          <div class="alert" :class="room ? 'alert-' + room.nickname : ''">
            <h5 class="font-weight-bold my-2">This Game has some additional questions/items of notes before you can proceed to book</h5>
          </div>

          <div class="tempus-iframe-div-box-shadow tempus-iframe-div-box-shadow-lighter tempus-iframe-form">
            <template v-for="question in room.room_questions">
              <div v-if="question.type == 'CHECKBOX'">
                <div class="row">
                  <div class="col">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        :class="{'is-invalid': roomQuestionResponseError[question.id]}"
                        type="checkbox"
                        :id="$id('question' + question.id)"
                        v-model="roomQuestionResponses[question.id]" value="1">
                      <label class="form-check-label font-weight-bold" :for="$id('question' + question.id)" >
                        <sup v-if="question.required" class="tempus-iframe-text-warning" data-toggle="tooltip" title="Required">(*)</sup>
                        {{ question.question }}
                      </label>
                    </div>
                  </div>
                </div>
                <hr/>
              </div>
              <div v-else-if="question.type == 'RADIO'">
                <div class="row">
                  <div class="col">
                    <p class="h5 font-weight-bold">
                      <sup v-if="question.required" class="tempus-iframe-text-warning" data-toggle="tooltip" title="Required">(*)</sup>
                    {{ question.question }}
                    </p>
                    <div v-for="(answer, key) in question.answer_options" class="form-check" :key="key" :class="{'is-invalid': roomQuestionResponseError[question.id]}">
                      <input
                        class="form-check-input"
                        :class="{'is-invalid': roomQuestionResponseError[question.id]}"
                        type="radio"
                        :id="$id('answer' + key)"
                        v-model="roomQuestionResponses[question.id]"
                        :value="answer"
                        :required="question.required">
                      <label class="form-check-label" :for="$id('answer' + key)">
                        {{ answer }}
                      </label>
                    </div>
                  </div>
                </div>
                <hr/>
              </div>
              <div v-else-if="question.type == 'DROPDOWN'">
                <div class="form-group row">
                  <label :for="$id('question' + question.id)" class="col-sm-6 col-form-label font-weight-bold">
                    <sup v-if="question.required" class="tempus-iframe-text-warning" data-toggle="tooltip" title="Required">(*)</sup>
                    {{ question.question }}
                  </label>
                  <div class="col-sm-6">
                    <select v-model="roomQuestionResponses[question.id]" class="form-control" :class="{'is-invalid': roomQuestionResponseError[question.id]}" :required="question.required">
                      <option :value="null">&lt;-- SELECT --&gt;</option>
                      <option v-for="answer in question.answer_options" :id="$id('question' + question.id)" :value="answer">{{ answer }}</option>
                    </select>
                  </div>
                </div>
                <hr/>
              </div>
              <div v-else-if="question.type == 'FREETEXT'">
                <div class="form-group row">
                  <label :for="$id('question' + question.id)" class="col-sm-6 col-form-label font-weight-bold">
                    <sup v-if="question.required" class="tempus-iframe-text-warning" data-toggle="tooltip" title="Required">(*)</sup>
                    {{ question.question }}
                  </label>
                  <div class="col-sm-6">
                    <textarea
                      v-model="roomQuestionResponses[question.id]"
                      class="form-control"
                      :class="{'is-invalid': roomQuestionResponseError[question.id]}"
                      rows="4"
                      :required="question.required"></textarea>
                  </div>
                </div>
                <hr/>
              </div>
            </template>
          </div>

          <p v-if="roomQuestionResponseErrors" class="font-weight-bold tempus-iframe-text-warning"><span class="material-icons text-orange" style="position: relative; top: 5px;">warning</span> {{ roomQuestionResponseErrors }}</p>

        </template>

        <p v-if="! enoughPlayersToProceed" class="tempus-iframe-text-warning font-italic"><span class="material-icons tempus-iframe-text-warning" style="position: relative; top: 5px;">warning</span> More players are required to proceed&hellip;</p>
        <p v-if="! enoughRoomQuestionsAnsweredToProceed" class="tempus-iframe-text-warning font-italic"><span class="material-icons text-orange" style="position: relative; top: 5px;">warning</span> Required Room Questions need to be responded to&hellip;</p>

        <div class="row mb-2">
          <div class="col text-center">
            <h5 class="pre-cart-description"><span class="font-weight-bold">{{ room.name }}</span> on {{ selectedRoomSlot.start | moment('ddd Do MMM YYYY') }} @ {{ roomSlotTimeText }}</h5>
          </div>
        </div>

        <div class="row pb-4">
          <div class="col btn-group">
            <button
              v-if="showAddToCart"
              type="button"
              class="btn btn-lg btn-tempus-blue-200"
              @click="addToCartButtonClicked(false)"
              :disabled="disableAddToCartButton">
              <span style="position: relative; top: -2px;">
                Add To Cart <span class="material-icons" style="position: relative; top: 5px;">add_shopping_cart</span>
              </span>
            </button>
            <button type="button"
              class="btn btn-lg btn-tempus-blue-300"
              @click="addToCartButtonClicked(true)"
              :disabled="disableAddToCartButton"
              >Add &amp; Checkout <span class="material-icons">shopping_cart_checkout</span>
            </button>
          </div>
        </div>

        <p v-if="disableAddToCartButton" class="font-italic tempus-iframe-text-warning">There are some actions to complete above to enable these buttons.</p>

        <p v-if="! this.enoughRoomQuestionsAnsweredToProceed" class="font-italic tempus-iframe-text-warning">There are Room Questions that need to be answered <a href="#roomQuestions" class="btn btn-tempus-blue-100" @click="moveToRoomQuestions">Answer Room Questions</a></p>

        <div class="row py-4">
          <div class="col btn-group">
            <button type="button" class="btn btn-lg btn-red" @click="$emit('try-another-room-slot')">
              Try another booking slot <span class="material-icons" style="position: relative; top: 5px;">undo</span>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    consoleDebug: {
      type: Boolean,
      default: false,
    },
    firstShow: {
      type: String,
      default: 'DEFAULT',
    },
    external: {
      type: Boolean,
      default: true,
    },
    location: {
      type: Object,
      required: true,
    },
    saleFrom: {
      type: String,
      default: 'R',
    },
    locationChildPricing: {
      type: Boolean,
    },
    selectedCustomer: {
      type: Object,
    },
    selectedRoomSlot: {
      type: Object,
    },
    addToCartButtonDisable: {
      type: Boolean,
    },
    bookingLabelAdults: {
      type: String,
      default: 'Adults',
    },
    bookingLabelAdultsSelection: {
      type: String,
      default: 'Select number of adults',
    },
    bookingChildCaveat: {
      type: String,
      default: 'Minimum of 2 adult tickets per game, regardless of age. A child is defined as 15 or younger.',
    },
    iframeScrollTransition: {
      type: Boolean,
    },
    pricingStyle: {
      type: String,
      default: 'DEFAULT',
    },
    allowZeroAdults: {
      type: Boolean,
      default: false,
    },
    showAddToCart: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      roomQuestionResponses: {},
      roomQuestionResponseErrors: null,
      roomQuestionResponseError: {},

      preCaveat: '<span class="heading font-italic">Attention:</span> ',

      numberOfAdults: 0,
      numberOfChildren: 0,

      numberOfPlayersError: '',
      numberOfAdultsError: '',
      numberOfChildrenError: '',

      checkoutAfterAdd: false,
    };
  },

  watch: {
    numberOfAdults(newValue, oldValue) {
      if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        if (this.allowZeroAdults) {
          if (newValue == 0) {
            if (this.numberOfChildren < this.enoughPlayersToProceed) {
              this.$emit('update:addToCartButtonDisable', true);
            } else {
              this.$emit('update:addToCartButtonDisable', false);
            }
          } else {
            if (this.numberOfPlayers < this.enoughPlayersToProceed) {
              this.$emit('update:addToCartButtonDisable', true);
            } else {
              this.$emit('update:addToCartButtonDisable', false);
            }
          }
        } else {
          // does not allow zero adults
          if (newValue == 0) {
            this.$emit('update:addToCartButtonDisable', true);
          } else {
            this.$emit('update:addToCartButtonDisable', false);
          }
        }
      } else {
        if (newValue > 0) {
          // this.addToCartButtonDisable = false;
          this.$emit('update:addToCartButtonDisable', false)
        } else {
          // this.addToCartButtonDisable = true;
          this.$emit('update:addToCartButtonDisable', true)
        }
      }
    },
    numberOfChildren(newValue, oldValue) {
      if (this.numberOfPlayers < this.enoughPlayersToProceed) {
        this.$emit('update:addToCartButtonDisable', true);
      } else {
        this.$emit('update:addToCartButtonDisable', false);
      }
    },
    selectedRoomSlot(newValue, oldValue) {
      if (this.consoleDebug) console.log('BookingCheckoutIframeRoomSlotPreCart -  WATCH: selectedRoomSlot', newValue, oldValue);
      if (newValue === null || newValue && oldValue && newValue.id != oldValue.id) {
        if (this.consoleDebug) console.log('BookingCheckoutIframeRoomSlotPreCart - WATCH: about to reset roomQuestionResponseError', this.roomQuestionResponseError);
        // they have pushed a new RoomSlot to the cart, so we need to wipe the RoomQuestions Answered
        this.roomQuestionResponses = {};
        this.roomQuestionResponseErrors = null;
        this.roomQuestionResponseError = {};
        if (this.consoleDebug) console.log('BookingCheckoutIframeRoomSlotPreCart WATCH: have reset roomQuestionResponseError', this.roomQuestionResponseError);
      }
    },
  },

  computed: {
    disableReduceAdultsQtyButton() {
      if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        if (this.allowZeroAdults) {
          return this.numberOfAdults == 0;
        }
        return this.numberOfAdults <= 1;
      }
      return false;
    },
    disableReduceChildrenQtyButton() {
      if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        // currently only used for the above pricing style
        return this.numberOfChildren == 0;
      }
      return false;
    },

    hasRoomQuestions() {
      return this.room && this.room.room_questions.length;
    },

    hasChildPricing() {
      // TODO: scope here to make it work for an individual Room
      return this.locationChildPricing;
    },

    numberOfPlayers() {
      return parseInt(this.numberOfAdults) + parseInt(this.numberOfChildren);
    },

    roomQuestionIdsRequired() {
      if (this.room && this.room.room_questions.length) {
        return this.room.room_questions.filter(rq => rq.required == 1).map(rq => rq.id);
      }
      return null;
    },

    enoughRoomQuestionsAnsweredToProceed() {
      if (! this.room) {
        return true;
      }
      if (this.room && this.room.room_questions.length == 0) {
        return true;
      }

      this.roomQuestionIdsRequired.forEach(rqid => {
        var iteratedId = this.room.room_questions.findIndex(rq => rq.id == rqid);

        if (this.room.room_questions[iteratedId].required == 1) {
          this.$set(this.roomQuestionResponseError, rqid, false);
          if (this.room.room_questions[iteratedId].type == 'CHECKBOX') {
            if (typeof(this.roomQuestionResponses[rqid]) == 'undefined' || this.roomQuestionResponses[rqid] === false) {
              this.$set(this.roomQuestionResponseError, rqid, true);
            }
          } else if (this.room.room_questions[iteratedId].type == 'RADIO' && typeof(this.roomQuestionResponses[rqid]) == 'undefined') {
            this.$set(this.roomQuestionResponseError, rqid, true);
          } else if (typeof(this.roomQuestionResponses[rqid]) == 'undefined' || this.roomQuestionResponses[rqid] == '' || this.roomQuestionResponses[rqid] == null) {
            this.$set(this.roomQuestionResponseError, rqid, true);
          }
        } else {

        }
      });

      if (Object.values(this.roomQuestionResponseError).includes(true)) {
        this.roomQuestionResponseErrors = 'There are Room Question(s) to answer';
        return false;
      } else {
        this.roomQuestionResponseErrors = null;
      }

      return true;
    },

    enoughPlayersToProceed() {
      if (! this.selectedRoomSlot) {
        return false;
      }
      if (this.hasChildPricing || this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        if (this.numberOfPlayers < this.roomSlotMinimimumPlayers) {
          return false;
        }
      }
      return true;
    },

    room() {
      if (this.selectedRoomSlot) {
        return this.location.rooms.find(room => room.id == this.selectedRoomSlot.room_id);
      } else if (this.virtualGame) {
        return this.location.virtual_games.find(room => room.id == this.virtualGame.id);
      }

      return null;
    },

    /**
     * Gives the rooms slot start and end time in the format "h:mm a - h:mm a".
     *
     * @return {string}
     */
    roomSlotTimeText() {
      if (this.selectedRoomSlot) {
        return moment(this.selectedRoomSlot.start).format('h:mm a') + ' - ' + moment(this.selectedRoomSlot.end).format('h:mm a');
      }

      return '';
    },

    numberOfPlayers() {
      return parseInt(this.numberOfAdults) + parseInt(this.numberOfChildren);
    },

    fromVirtualGame() {
      return this.virtualGame != null;
    },

    hasChildPricing() {
      // TODO: scope here to make it work for an individual Room
      return this.locationChildPricing;
    },

    roomSlotMinimimumPlayers() {
      if (this.selectedRoomSlot && this.selectedRoomSlot.override_play_min) {
        return this.selectedRoomSlot.override_play_min;
      }
      return this.room.play_min;
    },

    numPlayersInputOptions() {
      let options = [];

      if (this.hasChildPricing) {
        if (this.room) {
          for (var num_players = 2; num_players <= parseInt(this.selectedRoomSlot.availableRemainingTickets) - parseInt(this.numberOfChildren); num_players++) {
            if (this.adultPricingNotPlayerPricing === true) {
              if (num_players < this.roomSlotMinimimumPlayers) {
                options.push({
                  id: num_players,
                  text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(parseInt(num_players))) + ' pp | ' + this.roomSlotMinimimumPlayers + ' min.',
                });
              } else {
                options.push({
                  id: num_players,
                  text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(parseInt(num_players))) + ' pp',
                });
              }
            } else {
              if (num_players < this.roomSlotMinimimumPlayers) {
                options.push({
                  id: num_players,
                  text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(parseInt(num_players) + parseInt(this.numberOfChildren))) + ' pp | ' + this.roomSlotMinimimumPlayers + ' min.',
                });
              } else {
                options.push({
                  id: num_players,
                  text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(parseInt(num_players) + parseInt(this.numberOfChildren))) + ' pp',
                });
              }
            }
          }
        }
      } else {
        if (this.room) {
          for (var num_players = this.roomSlotMinimimumPlayers; num_players <= this.selectedRoomSlot.availableRemainingTickets; num_players++) {
            if (this.room && this.room.tour === true) {
              options.push({
                id: num_players,
                text: num_players + (num_players == 1 ? ' team ' : ' teams ') + '@ ' + this.$money(this.getPricePerPerson(num_players)),
              })
            } else {
              options.push({
                id: num_players,
                text: num_players + ' people @ ' + this.$money(this.getPricePerPerson(num_players)) + ' per person',
              })
            }
          }
        }
      }

      return options;
    },

    numChildrenInputOptions() {
      let options = [];

      if (this.hasChildPricing) {
        if (this.room) {
          for (var num_children = 0; num_children <= this.selectedRoomSlot.availableRemainingTickets - this.numberOfAdults; num_children++) {
          // for (var num_children in this.range(this.roomSlotMinimimumPlayers, this.room.play_max)) {
            if (num_children == 0) {
              var text = '0 children';
            } else if (num_children == 1) {
              var text = '1 child @ ' + this.$money(this.getPricePerChild(num_children));
            } else {
              var text = num_children + ' children @ ' + this.$money(this.getPricePerChild(num_children)) + ' per child';
            }
            options.push({
              id: num_children,
              text: text,
            })
          }
        }
      }

      return options;
    },

    disableAddToCartButton() {
      if (this.consoleDebug) console.log('BookingCheckoutIframeRoomSlotPreCart::disableAddToCartButton', this.numberOfPlayers, this.roomSlotMinimimumPlayers, this.numberOfPlayers < this.roomSlotMinimimumPlayers);
      return this.addToCartButtonDisable
        || ! this.enoughPlayersToProceed
        || ! this.enoughRoomQuestionsAnsweredToProceed
        || (this.pricingStyle == 'CHILD_TOTAL_PLAYERS' && ! this.allowZeroAdults && this.numberOfAdults == 0)
        || (this.pricingStyle == 'CHILD_TOTAL_PLAYERS' && this.numberOfPlayers < this.roomSlotMinimimumPlayers);
    },
  },

  methods: {
    moveToRoomQuestions() {
      this.$emit('move-to-room-questions');
    },
    backToCalendar() {
      this.$emit('back-to-calendar');
    },

    toPlayerEntry() {
      this.$emit('move-to-player-entry');
    },

    getPrice(num_adults, num_children, voucher = false) {
      // console.log('getPrice', num_adults, num_children, voucher, this.numberOfPlayers);

      if (num_adults == 0 && ! num_children) {
        return null;
      }

      var price;

      if (this.fromVirtualGame) {
        let preDiscountPrice = this.virtualGame.price;

        return preDiscountPrice;
      } else if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        price = {};
        if (this.room && this.room.prices.length) {
          if (num_children) {
            if (this.selectedRoomSlot.peakType == 'P') {
              return (this.room.prices.find(price => price.price_for == this.numberOfPlayers).peak * num_adults) + (this.room.prices.find(price => price.price_for == this.numberOfPlayers).peak_child * num_children);
            }
            return (this.room.prices.find(price => price.price_for == this.numberOfPlayers).offpeak * num_adults) + (this.room.prices.find(price => price.price_for == this.numberOfPlayers).offpeak_child * num_children);
          } else {
            if (this.selectedRoomSlot.peakType == 'P') {
              return this.room.prices.find(price => price.price_for == num_adults).peak * num_adults;
            }
            return this.room.prices.find(price => price.price_for == num_adults).offpeak * num_adults;
          }
        } else {
          if (num_children) {
            if (this.selectedRoomSlot.peakType == 'P') {
              return (this.location.prices.find(price => price.price_for == this.numberOfPlayers).peak * num_adults) + (this.location.prices.find(price => price.price_for == this.numberOfPlayers).peak_child * num_children);
            }
            return (this.location.prices.find(price => price.price_for == this.numberOfPlayers).offpeak * num_adults) + (this.location.prices.find(price => price.price_for == this.numberOfPlayers).offpeak_child * num_children);
          } else {
            if (this.selectedRoomSlot.peakType == 'P') {
              return this.location.prices.find(price => price.price_for == num_adults).peak * num_adults;
            }
            return this.location.prices.find(price => price.price_for == num_adults).offpeak * num_adults;
          }
        }

      } else {
        if (this.room && this.room.prices.length) {
          if (num_children) {
            price = {};
            var priceChildren = this.room.prices.find(price => price.price_for == num_children);
            var priceAdults = this.room.prices.find(price => price.price_for == this.numberOfPlayers);

            if (typeof(priceAdults) !== 'undefined') {
              price.peak = parseInt(priceChildren.peak_child) + parseInt(priceAdults.peak / this.numberOfPlayers * num_adults);
              price.offpeak = parseInt(priceChildren.offpeak_child) + parseInt(priceAdults.offpeak / this.numberOfPlayers * num_adults);
            } else {
              price.peak = parseInt(priceChildren.peak_child);
              price.offpeak = parseInt(priceChildren.offpeak_child);
            }
          } else {
            price = this.room.prices.find(price => price.price_for == num_adults);
          }
        }

        if (! price) {
          if (num_children) {
            price = {};
            var priceChildren = this.location.prices.find(price => price.price_for == num_children);
            var priceAdults = this.location.prices.find(price => price.price_for == num_adults);

            if (this.adultPricingNotPlayerPricing) {
              if (typeof(priceAdults) !== 'undefined') {
                price.peak = (num_children > 0 ? parseInt(priceChildren.peak_child) : 0) + parseInt(priceAdults.peak);
                price.offpeak = (num_children > 0 ? parseInt(priceChildren.offpeak_child) : 0) + parseInt(priceAdults.offpeak);
              } else {
                price.peak = parseInt(priceChildren.peak_child);
                price.offpeak = parseInt(priceChildren.offpeak_child);
              }
            } else {
              priceAdults = this.location.prices.find(price => price.price_for == this.numberOfPlayers);
              if (typeof(priceAdults) !== 'undefined') {
                price.peak = (num_children > 0 ? parseInt(priceChildren.peak_child) : 0) + parseInt(priceAdults.peak / this.numberOfPlayers * num_adults);
                price.offpeak = (num_children > 0 ? parseInt(priceChildren.offpeak_child) : 0) + parseInt(priceAdults.offpeak / this.numberOfPlayers * num_adults);
              } else {
                price.peak = parseInt(priceChildren.peak_child);
                price.offpeak = parseInt(priceChildren.offpeak_child);
              }
            }

          } else {
            price = this.location.prices.find(price => price.price_for == num_adults);
          }
        }

        if (voucher) {
          if (voucher.type == 'P') {
            return price.peak;
          } else {
            return price.offpeak;
          }
        }

        if (this.selectedRoomSlot.peakType == 'P') {
          return price.peak;
        } else {
          return price.offpeak;
        }
      }
    }, // getPrice()

    getPricePerPerson(num_players) {
      // console.log('getPricePerPerson', num_players);
      return this.getPrice(num_players, 0) / num_players;
    }, // getPricePerPerson()

    getPricePerChild(num_children) {
      // console.log('getPricePerChild', num_children);e
      return this.getPrice(0, num_children) / num_children;
    }, // getPricePerChild()

    resetBookModalInputs() {
      // need to reset this as if a different room is select it might have a different play_max
      this.numberOfAdults = 0;
      this.numberOfChildren = 0;
      this.roomQuestionResponses = {};
      this.roomQuestionResponseErrors = null;
      this.roomQuestionResponseError = {};
    }, // resetBookModalInputs()

    addToCartButtonClicked(checkoutAfterAdd) {
      if (this.consoleDebug) console.log('BookingCheckoutIframeRoomSlotPreCart::addToCartButtonClicked', checkoutAfterAdd);
      // if the customer is not selected, we need to input their details

      if (this.selectedCustomer == null) {
        if (this.consoleDebug) console.log('BookingCheckoutIframeRoomSlotPreCart::addToCartButtonClicked | selectedCustomer == null');
        this.getCustomerDetails(checkoutAfterAdd)
        return false;
      }

      let request = {
        location: this.location.slug,
        cartable: 'App\\Models\\RoomSlot:' + this.selectedRoomSlot.id,
        quantity: this.numberOfPlayers,
        options: {
          adults: this.numberOfAdults,
          children: this.numberOfChildren,
          saleFrom: this.saleFrom,
        },
        soldFor: this.getPrice(this.numberOfAdults, this.numberOfChildren),
        notes: null,
        roomResponses: this.roomQuestionResponses,
      };

      this.$emit('add-room-slot-to-cart', {request: request, checkoutAfterAdd: checkoutAfterAdd});
    }, // addToCartButtonClicked()

    getCustomerDetails(checkoutAfterAdd) {
      if (this.consoleDebug) console.log('BookingCheckoutIframeRoomSlotPreCart::emitted get-customer-details', checkoutAfterAdd);
      this.$emit('get-customer-details', checkoutAfterAdd);
    }, // getCustomerDetails()
  },

  mounted() {

  },
}
</script>
